import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apartmentsImg from '@/assets/images/apartments.png';
import villasImg from '@/assets/images/villas.png';
import commercialsImg from '@/assets/images/apartments.png'; // Fallback to apartments if commercials image is missing
import plotsImg from '@/assets/images/plots.png';
import serviceApartmentsImg from '@/assets/images/service_apartments.png';
import hospitalityImg from '@/assets/images/hospitality.png';
import propertySearchBg from '@/assets/images/property_search_new_bg.png';
import { hashEncode } from '@/utility';
import './PropertySearch.css';

const PropertySearch = () => {

  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem('activeTab') || 'buy';
  });
  const [activePropertyType, setActivePropertyType] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [isLocating, setIsLocating] = useState(false);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    localStorage.setItem('activeTab', tab);
  };

  const propertyTypes = [
    { id: '9', name: 'Apartments', img: apartmentsImg },
    { id: '10', name: 'Villas & Row Houses', img: villasImg },
    { id: '12', name: 'Commercials', img: commercialsImg },
    { id: '11', name: 'Plots/land', img: plotsImg },
    { id: '13', name: 'Service Apartments', img: serviceApartmentsImg },
    { id: '14', name: 'Hospitality', img: hospitalityImg },
    { id: '184', name: 'Farm house/land', img: hospitalityImg },
  ];

  const handleNearMeClick = () => {
    if (!navigator.geolocation) {
      alert("Geolocation is not supported by your browser");
      return;
    }
    setIsLocating(true);
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        // Store user coordinates in browser local storage
        localStorage.setItem('latitude', latitude);
        localStorage.setItem('longitude', longitude);
        localStorage.setItem('user_latitude', latitude);
        localStorage.setItem('user_longitude', longitude);
        console.log(latitude, longitude)

        try {
          // Attempt to reverse geocode and fill search input for immediate UX feedback
          const res = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`, {
            headers: {
              'User-Agent': 'KisanGatewayApp/1.0'
            }
          });
          const data = await res.json();
          const city = data?.address?.city || data?.address?.town || data?.address?.village || data?.address?.state_district || "";
          if (city) {
            setSearchQuery(city);
          }
        } catch (e) {
          console.error("Failed to reverse-geocode user location coordinates", e);
        } finally {
          setIsLocating(false);
        }
      },
      (error) => {
        console.error("Geolocation request failed", error);
        alert("Location access denied or unavailable. Please enter location manually.");
        setIsLocating(false);
      },
      { enableHighAccuracy: true, timeout: 10000 }
    );
  };

  const handleSearch = () => {
    let queryToSearch = searchQuery.trim();
    if (activePropertyType) {
      const cid = hashEncode(Number(activePropertyType));
      let searchUrl = `/search?cid=${encodeURIComponent(cid)}`;
      if (queryToSearch) {
        searchUrl += `&query=${encodeURIComponent(queryToSearch)}`;
      }
      navigate(searchUrl);
    } else {
      if (!queryToSearch) return;
      navigate(`/search?query=${encodeURIComponent(queryToSearch)}`);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleSearch();
  };

  return (
    <div className="w-100" style={{
      backgroundImage: `url(${propertySearchBg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      padding: '50px 0'
    }}>
      <style>{`
        @keyframes spin-anim {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .rotate-animation {
          animation: spin-anim 1s linear infinite;
        }
      `}</style>
      <div className="container" >
        <div className="" style={{
          backgroundColor: '#FCF2FF',
          borderRadius: '24px',
          padding: '24px 32px',
        }}>

          {/* Top Tabs */}
          <div className="d-inline-flex mb-3 p-1" style={{ backgroundColor: '#F3E8FA', borderRadius: '32px' }}>
            <button
              className={`btn rounded-pill border-0 fw-semibold ${activeTab === 'buy' ? 'text-white' : 'text-dark'}`}
              style={{
                backgroundColor: activeTab === 'buy' ? '#6B2E8C' : 'transparent',
                fontSize: '14px',
                padding: '6px 48px',
                transition: 'all 0.2s ease'
              }}
              onClick={() => handleTabChange('buy')}
            >
              Buy
            </button>
            <button
              className={`btn rounded-pill border-0 fw-semibold ${activeTab === 'rentals' ? 'text-white' : 'text-dark'}`}
              style={{
                backgroundColor: activeTab === 'rentals' ? '#6B2E8C' : 'transparent',
                fontSize: '14px',
                padding: '6px 48px',
                transition: 'all 0.2s ease'
              }}
              onClick={() => handleTabChange('rentals')}
            >
              Rentals
            </button>
          </div>

          {/* Property Types */}
          <div className="d-flex flex-nowrap overflow-auto gap-3 mb-4 pb-2 pt-1 px-1" style={{ scrollbarWidth: 'none' }}>
            {propertyTypes.map(type => {
              const isActive = activePropertyType === type.id;
              return (
                <div
                  key={type.id}
                  className="position-relative d-flex align-items-center cursor-pointer transition shadow-sm text-nowrap"
                  onClick={() => setActivePropertyType(type.id)}
                  style={{
                    padding: '8px 10px',
                    border: isActive ? '1.5px solid #6B2E8C' : '1px solid #F0F0F0',
                    borderRadius: '12px',
                    backgroundColor: '#FFFFFF',
                    minWidth: 'fit-content'
                  }}
                >
                  <div className="d-flex align-items-center justify-content-center me-2" style={{ width: '32px', height: '32px' }}>
                    <img src={type.img} alt={type.name} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                  </div>
                  <span style={{
                    color: isActive ? '#000' : '#4D4D4D',
                    fontSize: '14px',
                    fontWeight: isActive ? '600' : '400'
                  }}>
                    {type.name}
                  </span>

                  {/* Active Indicator Triangle */}
                  {isActive && (
                    <div style={{
                      position: 'absolute',
                      bottom: '-7px',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      width: '0',
                      height: '0',
                      borderLeft: '6px solid transparent',
                      borderRight: '6px solid transparent',
                      borderTop: '6px solid #6B2E8C',
                    }}></div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Search Bar Row */}
          <div className="search-row-container">
            <div className="search-input-wrapper">
              <i className="bi bi-search me-2" style={{ color: '#8824A4', fontSize: '18px' }}></i>
              <input
                type="text"
                className="form-control border-0 shadow-none bg-transparent flex-grow-1 px-2 search-input-field"
                placeholder="Search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <div
                className="near-me-btn"
                onClick={handleNearMeClick}
                style={{ cursor: isLocating ? 'wait' : 'pointer', opacity: isLocating ? 0.7 : 1 }}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className={`me-2 ${isLocating ? 'rotate-animation' : ''}`}
                >
                  <circle cx="8" cy="8" r="3.5" stroke="#E23030" strokeWidth="1.2" />
                  <circle cx="8" cy="8" r="1.5" fill="#E23030" />
                  <path d="M8 1V3.5" stroke="#E23030" strokeWidth="1.2" strokeLinecap="round" />
                  <path d="M8 12.5V15" stroke="#E23030" strokeWidth="1.2" strokeLinecap="round" />
                  <path d="M1 8H3.5" stroke="#E23030" strokeWidth="1.2" strokeLinecap="round" />
                  <path d="M12.5 8H15" stroke="#E23030" strokeWidth="1.2" strokeLinecap="round" />
                </svg>
                <span style={{ color: '#666666', fontSize: '14px', fontWeight: '500' }}>
                  {isLocating ? 'Locating...' : 'Near Me'}
                </span>
              </div>
            </div>

            <button className="btn search-btn" onClick={handleSearch}>
              Search
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="ms-2">
                <path d="M9 18l6-6-6-6" />
              </svg>
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default PropertySearch;

